namespace $.$$ {

		type $shm_dashboard_admin_server_stats = {
		memory: { total: number, used: number, available: number }
		process: { rss: number }
		disk: { total: number, used: number, available: number }
		storage: { total: number, files: number, collections: readonly { id: string, name: string, files: number, bytes: number }[] }
		history: readonly {
			day: string, disk_total: number, disk_used: number, disk_available: number,
			pb_storage: number, pb_files: number,
		}[]
	}
	type $shm_dashboard_admin_server_history = $shm_dashboard_admin_server_stats[ 'history' ]

	export class $shm_dashboard_admin_server extends $.$shm_dashboard_admin_server {

		@ $mol_mem
		refresh_version( next?: number ) { return next ?? 0 }

		@ $mol_mem
		stats() {
			this.refresh_version()
			return this.$.$mol_fetch.json( `${ this.$.$shm_pb.url() }/api/hitalama/server/stats`, {
				cache: 'no-store',
				headers: this.$.$shm_pb.admin_headers(),
			} ) as $shm_dashboard_admin_server_stats
		}

		@ $mol_action
		refresh( next?: Event ) {
			if( next === undefined ) return null
			this.refresh_version( this.refresh_version() + 1 )
			return next
		}

		format_bytes( bytes: number ) {
			if( !Number.isFinite( bytes ) || bytes < 0 ) return '—'
			const units = [ 'Б', 'КБ', 'МБ', 'ГБ', 'ТБ' ]
			let value = bytes
			let unit = 0
			while( value >= 1024 && unit < units.length - 1 ) { value /= 1024; ++ unit }
			return `${ value.toLocaleString( 'ru-RU', { maximumFractionDigits: unit ? 1 : 0 } ) } ${ units[ unit ] }`
		}

		memory_usage() {
			const memory = this.stats().memory
			return `${ this.format_bytes( memory.used ) } из ${ this.format_bytes( memory.total ) }`
		}
		memory_available() { return this.format_bytes( this.stats().memory.available ) }
		process_memory() { return this.format_bytes( this.stats().process.rss ) }
		disk_usage() {
			const disk = this.stats().disk
			return `${ this.format_bytes( disk.used ) } из ${ this.format_bytes( disk.total ) }`
		}
		storage_total() { return this.format_bytes( this.stats().storage.total ) }

		storage_rows() {
			const rows = this.stats().storage.collections
			return rows.length ? rows.map( row => this.Storage_row( row.id ) ) : [ this.Empty() ]
		}

		storage_record( id: string ) { return this.stats().storage.collections.find( row => row.id === id ) }
		storage_name( id: string ) { return this.storage_record( id )?.name ?? id }
		storage_files( id: string ) { return `${ this.storage_record( id )?.files ?? 0 } файлов` }
		storage_size( id: string ) { return this.format_bytes( this.storage_record( id )?.bytes ?? 0 ) }
		metric_history() {
			const history = this.stats().history
			return Array.isArray( history ) ? history : []
		}
	}

	export class $shm_dashboard_admin_server_charts extends $.$shm_dashboard_admin_server_charts {

		history_rows() {
			const history = this.metric_history()
			return Array.isArray( history ) ? history as $shm_dashboard_admin_server_history : []
		}

		history_labels() {
			return this.history_rows().map( row => {
				const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec( row.day )
				return match ? `${ match[3] }.${ match[2] }.${ match[1] }` : row.day
			} )
		}
		disk_used_series() {
			return this.history_rows().map( row => row.disk_total ? row.disk_used / row.disk_total * 100 : 0 )
		}
		pb_storage_series() { return this.history_rows().map( row => row.pb_storage / 1024 ** 2 ) }
	}
}
